// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__cD7L6","title":"Info_title__2ubSc","links":"Info_links__3oY-j","link":"Info_link__1fgX_","logo":"Info_logo__3JfOu"};